import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import './css/normalize.css';
import './css/style.css';
import './css/fontawesome.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js